import { ArrayInput } from '../../../components/admin/array-input';
import { required, useTranslate } from 'ra-core';
import { AddTaskButton } from './ChecklistTaskAddButton';
import { ChecklistTaskInput } from './ChecklistTaskInput';
import { MoonstarFormIterator } from '../../Moonstar/MoonstarFormIterator';

export function ChecklistTasksInput() {
  const translate = useTranslate();

  return (
    <section className="flex flex-col gap-2 rounded-lg border p-4">
      <h3 className="mt-2 text-lg font-semibold">
        {translate('moonstar.checklists.form.taskList')}
      </h3>
      <ArrayInput
        source="tasks"
        label={false}
        helperText={false}
        validate={required()}
      >
        <MoonstarFormIterator addButton={<AddTaskButton />} collapsibleItems>
          <ChecklistTaskInput />
        </MoonstarFormIterator>
      </ArrayInput>
    </section>
  );
}
